<div
  class="input-wrap datepicker"
  #t="ngbTooltip"
  [ngbTooltip]="validationMessage"
  triggers="manual"
  container="body"
  tooltipClass="tooltip-error"
  placement="bottom"
  [autoClose]="false"
  [class.disabled]="disabled"
>
  <input
    type="text"
    #dateinput
    [class.invalid]="isDateInvalid"
    [(ngModel)]="value"
    [placeholder]="placeholder"
    [mask]="mask"
    (blur)="onBlur($event)"
    (ngModelChange)="onDateInputChange($event)"
    [leadZeroDateTime]="true"
    [dropSpecialCharacters]="false"
  />

  <input
    type="hidden"
    (dateSelect)="onDateSelect($event)"
    ngbDatepicker
    [(ngModel)]="calendarValue"
    #datepicker="ngbDatepicker"
    name="datepicker"
    [maxDate]="maxDate"
    [minDate]="minDate"
    [positionTarget]="dateinput"
  />

  <button type="button" class="datepicker-button" (click)="datepicker.toggle()">
    <i class="fas fa-calendar-alt"></i>
  </button>
</div>

<div
  class="invalid-feedback d-block text-left"
  *ngIf="isDateInvalid && !hasTooltipValidation"
>
  {{ validationMessage }}
</div>
